import { ChangeEvent, useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import UserNavBar from "./UserNavBar";

const AddUser =  () => {
	var firstNameRef = useRef<HTMLInputElement>(null)
	var lastNameRef = useRef<HTMLInputElement>(null)
	var middleNameRef = useRef<HTMLInputElement>(null)
	var emailRef = useRef<HTMLInputElement>(null)
	var passwordRef = useRef<HTMLInputElement>(null)
	var roleRef = useRef<HTMLSelectElement>(null)

	interface Unit {
		id: number
		unit: string
		active: boolean
	}
	
	interface FileUploadState {
		file: File | null;
		previewUrl: string | null;
	}

	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}

	const [locations, setLocations] = useState<Location[]>([])
	const [defaultUnit, setDefaultUnit] = useState<Unit>({id:0, unit:"", active: false})
	const [selectedLocations, setSelectedLocations] = useState<string[]>([])
	const [units, setUnits] = useState<Unit[]>([])
	const [selectedUnits, setSelectedUnits] = useState<string[]>([])
	const [respMsg, setRespMsg] = useState("")
	const [fileState, setFileState] = useState<FileUploadState>({
		file: null,
		previewUrl: null,
	});
	const [inputKey, setInputKey] = useState(Date.now());

	const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files;
		if (files && files.length > 0) {
			const selectedFile = files[0];
			setFileState({
				file: selectedFile,
				previewUrl: (window.URL ? URL : webkitURL).createObjectURL(selectedFile),
			});
		}
	};
	
	const handleUnitsChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const values = Array.from(event.target.selectedOptions, (option) => option.value);
		setSelectedUnits(values)
	}

	const handleLocationsChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const values = Array.from(event.target.selectedOptions, (option) => option.value);
		setSelectedLocations(values)
	}

	const handleDefaultUnitChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const value = event.target.value;
		const unit = units.find(loc => loc.id.toString() ===
			value)
		if (unit) {
			setDefaultUnit(unit)
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		const results = await response.json()
		setLocations(results)
	}
	
	useEffect(() => {
		const getUnits = async () => {
			const response = await fetch(process.env.REACT_APP_API+"/api/units")
			const results = await response.json()
			// remove this
			var units: Unit[] = []
			for (var i= 0; i < results.length; i++) {
				var unit:Unit = {id: results[i].id, unit:results[i].unit, active:results[i].active}
				units.push(unit)
			}
			setUnits(results)
		}
		getUnits()
		getLocations()
		return () => {
			if (fileState.previewUrl) {
				URL.revokeObjectURL(fileState.previewUrl);
			}
		};
	}, [fileState.previewUrl]);
	
	async function addUser() {

		if (firstNameRef && firstNameRef.current && firstNameRef.current.value !== "" &&
			lastNameRef && lastNameRef.current && lastNameRef.current.value !== "" &&
			selectedUnits.length > 0 && selectedLocations.length > 0 
		) {
			const formData = new FormData()
			formData.append("first_name", firstNameRef.current.value)
			formData.append("last_name", lastNameRef.current.value)
			formData.append("middle_name", middleNameRef.current ? middleNameRef.current.value : "")
			if (fileState && fileState.file) {
				formData.append("photo", fileState.file)
			}
			if (emailRef && emailRef.current) {
				formData.append("email", emailRef.current.value)
			}
			if (passwordRef && passwordRef.current) {
				formData.append("password", passwordRef.current.value)
			}
			if (roleRef && roleRef.current) {
				formData.append("role", roleRef.current.value)
			}
			formData.append("units", JSON.stringify(selectedUnits))
			formData.append("locations", JSON.stringify(selectedLocations))
			formData.append("default_unit", defaultUnit.id.toString())

			const resp = await fetch(process.env.REACT_APP_API+"/api/user", {
				method: "POST",
				body: formData
			})
			const msg = await resp.json()
			setRespMsg(msg.msg)
			firstNameRef.current.value=""
			lastNameRef.current.value=""
			if (middleNameRef && middleNameRef.current) {
				middleNameRef.current.value=""
			}
			if (emailRef && emailRef.current) {
				emailRef.current.value=""
			}
			if (passwordRef && passwordRef.current) {
				passwordRef.current.value = ""
			}
			if (roleRef && roleRef.current) {
				roleRef.current.value = "clinic"
			}
			if (fileState.previewUrl) {
				fileState.previewUrl = null
			}
			if (fileState.file) {
				fileState.file = null
			}
			setFileState({
				file: null,
				previewUrl: null,
			});
			setInputKey(Date.now())

			// clear units and locations
			setSelectedUnits([])
			setSelectedLocations([])
			setDefaultUnit({id:0, unit:"", active: false})
		} else {
			setRespMsg("First name, last name, unit and location are required")
		}
	}

	return (
		<div className="resilire">
			<AdminNavBar />
			<UserNavBar />
			<h3>Add User</h3>
			<label htmlFor="first_name">First Name</label>
			<input id="first_name" name="first_name" ref={firstNameRef}></input>
			<label htmlFor="middle_name">Middle Name</label>
			<input id="middle_name" name="middle_name" ref={middleNameRef}></input>
			<label htmlFor="last_name">Last Name</label>
			<input id="last_name" name="last_name" ref={lastNameRef}></input>
			<label htmlFor="email">Username</label>
			<input type="email" name="email" ref={emailRef} />
			<label htmlFor="password">Password</label>
			<input type="password" name="password" ref={passwordRef} />
			<label htmlFor="units">Units</label>
			<select id="units" name="units" size={1} value={selectedUnits} onChange={handleUnitsChange} multiple>
				{
					units.map((unit) => (
						<option value={unit.id} key={unit.id}>{unit.unit}</option>
					))
				}
			</select>

			<label htmlFor="locations">Locations</label>
			<select id="locations" name="locations" value={selectedLocations} size={1} onChange={handleLocationsChange} multiple>
				{
					locations.map((location) => (
						<option value={location.id} key={location.id}>{location.short_name} - {location.long_name}</option>
					))
				}
			</select>
			<label htmlFor="default_unit">Default Unit</label>
			<select id="default_unit" name="default_unit" value={defaultUnit.id} size={1} onChange={handleDefaultUnitChange}>
				<option value=""></option>
				{
					units.map((unit) => (
						<option value={unit.id} key={unit.id}>{unit.unit}</option>
					))
				}
			</select>
			<label htmlFor="role">Role</label>
			<select id="role" name="role" ref={roleRef}>
				<option value="clinic">In-Clinic</option>
				<option value="admin">Admin</option>
				<option value="mobile">Mobile</option>
			</select>
			<label htmlFor="photo">Photo</label>
			<input type="file" accept="image/*" onChange={handleFileChange} key={inputKey} />

			{fileState.previewUrl && (
				<img src={fileState.previewUrl} alt="Preview" style={{ maxWidth: '200px', marginTop: '10px' }} />
			)}

			<button onClick={addUser}>Submit</button>

			{respMsg && (
				<div className="resilire">
					{respMsg}
				</div>
			)}
		</div>
	);
};

export default AddUser;
